export default () => (
  <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 2.8125C8.28 2.8125 2.8125 8.28 2.8125 15C2.8125 21.72 8.28 27.1875 15 27.1875C21.72 27.1875 27.1875 21.72 27.1875 15C27.1875 8.28 21.72 2.8125 15 2.8125ZM15 4.6875C20.7066 4.6875 25.3125 9.29344 25.3125 15C25.3125 20.7066 20.7066 25.3125 15 25.3125C9.29344 25.3125 4.6875 20.7066 4.6875 15C4.6875 9.29344 9.29344 4.6875 15 4.6875ZM14.0625 9.375V14.0625H9.375V15.9375H14.0625V20.625H15.9375V15.9375H20.625V14.0625H15.9375V9.375H14.0625Z"
      fill="currentColor"
    />
  </svg>
);
